import { CommonModule } from '@angular/common';
import { Component, effect } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { Subscription } from 'rxjs';
import { Binder } from 'src/app/models/binder.model';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { Lender, LenderContact } from '@/models/bank-models.model';
import { BinderService } from '@/services/api/binder.service';
import { LendersService } from '@/services/api/lenders.service';
import { SettingsDialogService } from '@/services/app/settings-dialog.service';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'app-new-client-settings',
    imports: [
      InputTextModule, 
      InputGroupModule, 
      CommonModule, 
      FormsModule, 
      ToggleSwitchModule, 
      InputNumberModule, 
      SelectButtonModule, 
      ButtonModule, 
      ReactiveFormsModule,
      SelectModule
    ],
    template: `
    <div #newClientSettingsDialog>
    <form [formGroup]="newClientForm" (ngSubmit)="onSave($event)" [class.p-disabled]="loading" class="w-50">
<div class="flex">
    <div class="flex flex-col gap-4 w-full">
        <div class="font-semibold text-lg">Site Details</div>
        <div class="flex flex-col md:flex-row gap-4">
            <div class="flex flex-col grow basis-0 gap-2 w-full">
                <label for="powerCo">Power Company</label>
                <input pInputText id="powerCo" type="text" pInputText formControlName="powerCo"
                    styleClass="w-full" />
            </div>
            <div class="flex flex-col grow basis-0 gap-2 w-full">
                <label for="powerLoc">Power Location</label>
                <input pInputText id="powerLoc" type="text" pInputText formControlName="powerLoc"
                    styleClass="w-full" />
            </div>
        </div>
        <div class="flex flex-col md:flex-row gap-4">
            <div class="flex flex-col grow basis-0 gap-2 w-full">
                <label for="septic">Septic</label>
                <p-selectButton id="septic" [options]="boolOptions" formControlName="septic" optionLabel="label"
                    optionValue="value" styleClass="w-full" />
            </div>
            <div class="flex flex-col grow basis-0 gap-2 w-full">
                <label for="septicDesigned" *ngIf="newClientForm.value.septic">Septic Designed</label>
                <p-selectButton id="septicDesigned" *ngIf="newClientForm.value.septic" [options]="boolOptions"
                    formControlName="septicDesigned" optionLabel="label" optionValue="value" styleClass="w-full" />
            </div>
        </div>
        <div class="flex flex-col md:flex-row gap-4">
            <div class="flex flex-col grow basis-0 gap-2 w-full">
                <label for="waterSupply">Water Supply</label>
                <p-select id="waterSupply" [options]="waterOptions" formControlName="waterSupply"
                    placeholder="Select an option" styleClass="w-full"></p-select>
            </div>
            <div class="flex flex-col grow basis-0 gap-2 w-full">
                <label for="wetlands">Wetlands On Site</label>
                <p-selectButton id="wetlands" [options]="boolOptions" formControlName="wetlands" optionLabel="label"
                    optionValue="value" styleClass="w-full" />
            </div>
        </div>
    </div>
</div>
<div class="flex mt-8 mb-8">
    <div class="flex flex-col gap-4 w-full">
        <div class="font-semibold text-lg">Lender Details</div>
        <div class="flex flex-col md:flex-row gap-4">
            <div class="flex flex-col grow basis-0 gap-2 w-full">
            <label>Lender</label>
                    <p-select [style]="{'width': '100%'}" id="lender" [options]="lenders" formControlName="LenderID"
                        optionLabel="Title" optionValue="LenderID" placeholder="Select a Lender" id="lender"
                        (onChange)="onLenderChange($event)"></p-select>
            </div>
            <div class="flex flex-col grow basis-0 gap-2 w-full">
            <label>Loan Officer</label>
                    <div class="flex flex-column md:flex-row md:align-items-center md:justify-content-between">
                        <div class="flex" *ngIf="currentContact">
                            <i class="pi pi-user mr-3" style="font-size: 3rem"></i>
                            <div class="mr-0 md:mr-8">
                                <span class="block text-900 font-medium mb-1">{{currentContact.contactFirstName ||
                                    'N/A'}}
                                    {{currentContact.contactLastName || ''}}</span>
                                <div class="text-600">{{currentContact.contactPhone || 'N/A'}}</div>
                                <div class="text-600">{{currentContact.contactEmail || 'N/A'}}</div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <div class="flex flex-col md:flex-row gap-4">
            <div class="flex flex-col grow basis-0 gap-2 w-full">
            <label for="approvalAmount">Pre-Approved For</label>
                    <p-inputNumber inputId="approvalAmount" mode="currency" currency="USD" locale="en-US"
                        type="text" formControlName="preapprovedAmount" />
            </div>
            <div class="flex flex-col grow basis-0 gap-2 w-full">
                
            </div>
        </div>
    </div>
</div>
</form>
<div class="flex flex-col sm:flex-row w-full gap-4">
        <span class="text-right mr-3"></span>
        <button pButton pRipple label="Save" icon="pi pi-save" class="w-auto ml-auto" [loading]="loading" (click)="onSave($event)"></button>
        </div>
        </div>
    `
})
export class NewClientSettingsComponent {
  binder!: Binder;
  subscriptions: Subscription[] = []
  newClientForm!: FormGroup;
  currentContact!: LenderContact;
  loading = false;
  boolOptions = [
    {label: 'Yes', value: true},
    {label: 'No', value: false}
  ];
  waterOptions = [
    'Public',
    'Well'
  ];

  constructor(
    private formBuilder: FormBuilder,
    private lenderModelService: LendersService,
    private binderService: BinderService,
    private settingsDialogService: SettingsDialogService
  ) {
    this.initForm();
    effect(() => {
      const binder = this.binderService.currentBinder();
      const lenders = this.lenderModelService.lenders();
      if(binder) {
        this.binder = binder;
        if(this.binder.LenderID) {
          this.changeContactInfo(this.binder.SelectedFID, this.binder.LenderID);
        }
        this.patchForm(this.binder);
      }
      if(lenders) {
        if(this.binder && this.binder.LenderID) {
          this.changeContactInfo(this.binder.SelectedFID, this.binder.LenderID);
        }
    }
    })
    effect(() => {
      const isOpen = this.settingsDialogService.isDialogOpen();
      if(isOpen) {
        this.patchForm(this.binder);
      }
    })
   }

  initForm() {
    this.newClientForm = this.formBuilder.group({
      LenderID: [0],
      powerCo: [''],
      waterSupply: [''],
      septicDesigned: [false],
      preapprovedAmount: [0],
      wetlands: [false],
      powerLoc: [''],
      septic: [false],
    });
  }

  get lenders() {
    return this.lenderModelService.lenders();
  }

  changeContactInfo(FID:number,LenderID:number) {
    const lender = this.lenders.find(l => l.LenderID === LenderID);
    this.currentContact = lender?.LenderContacts?.find((c: LenderContact) => c.FID === FID) as LenderContact;
  }

    onSave(event: Event) {
      event.preventDefault(); // Prevent default form submission
  this.loading = true;
      if (this.newClientForm.valid) {
        const formData = this.newClientForm.value;
        this.binderService.updateBinder(this.binder.BinderID, formData).subscribe((updatedBinder) => {
          this.binderService.setCurrentBinder(updatedBinder);
        });
        this.loading = false;
        this.settingsDialogService.toggleDialog('New Client Settings', 1, false);
      }
    }

    onLenderChange(event: any) {
      this.changeContactInfo(this.binder.SelectedFID, event.value);
    }

patchForm(binder: Binder) {
  this.newClientForm.patchValue({
    LenderID: binder.LenderID,
    powerCo: binder.powerCo,
    waterSupply: binder.waterSupply,
    septicDesigned: binder.septicDesigned,
    preapprovedAmount: binder.preapprovedAmount,
    wetlands: binder.wetlands,
    powerLoc: binder.powerLoc,
    septic: binder.septic
  });
}

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
